import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

import { RouteLocationNormalized, RouteRecordNormalized, RouteRecordName } from 'vue-router'
import animateRouter from '@mobile/router/animateRouter'
import RouterTransition from '@mobile/components/base/router-transition/index.vue'
import http from '@/services/http'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { transitionName, excludeViews } = animateRouter.getStateRef()

// 手动给组件添加 name 属性，处理缓存 exclude 无效的问题
const handleComponent = (component: Record<'type', { name: RouteRecordName | undefined }>, route: RouteRecordNormalized) => {
  if (component) {
    component.type.name = route.name
  }
  return component
}

// key 的作用是当 $route.query 参数发生变化时会刷新页面
// 不直接使用 $route.fullPath 的原因是每次都会刷新页面，导致嵌套路由缓存失效
const getRouteKey = (route: RouteLocationNormalized) => {
  const qs = Object.keys(route.query)
  return qs.length ? route.fullPath : undefined
}

const onLeave = () => {
  http.pending = true
}

const onAfterEnter = () => {
  http.pending = false
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, { class: "app-page" }, {
    default: _withCtx(({ Component, route }) => [
      _createVNode(RouterTransition, {
        "transition-name": _unref(transitionName),
        onLeave: onLeave,
        onAfterEnter: onAfterEnter
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_KeepAlive, { exclude: _unref(excludeViews) }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(handleComponent(Component, route)), {
              key: getRouteKey(route)
            }))
          ], 1032, ["exclude"]))
        ]),
        _: 2
      }, 1032, ["transition-name"])
    ]),
    _: 1
  }))
}
}

})